module.exports = __webpack_public_path__ + "img/canbadge_daishi_50_60mm.72424db5.png";